import { Component, EventEmitter, Input } from '@angular/core';
import OfferUtils from 'src/app/public/store/utils/OfferUtils';
import { Offer, OrderItem } from 'src/app/stores/stores';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-offer-actions',
  templateUrl: './offer-actions.component.html',
  styleUrls: ['./offer-actions.component.scss'],
})
export class OfferActionsComponent {
  @Input() itemAddedToCart: EventEmitter<{
    offerId: number;
    categoryId: number;
    inStock: boolean;
    isDirectlyOrderable: boolean;
    isExpandable: boolean;
    isOrderable: boolean;
    basketEnabled: boolean;
  }>;
  @Input() decreaseItemQty: EventEmitter<OrderItem>;
  @Input() currentCartStatus: string;
  @Input() offer: Offer;
  @Input() cartItems: OrderItem[];
  @Input() basketEnabled = true;
  @Input() size: 'small' | 'regular' = 'regular';
  @Input() orderingEnabled = true;

  constructor(
    private sanitizer: DomSanitizer,
  ) {}

  onOneClickAddToCart(event) {
    event.stopPropagation();
    const { offerId, categoryId, inStock, isDirectlyOrderable, isExpandable, isOrderable } = this.offer;
    this.itemAddedToCart.emit({
      offerId,
      categoryId,
      inStock,
      isDirectlyOrderable,
      isExpandable,
      isOrderable,
      basketEnabled: this.basketEnabled,
    });
  }

  onDecreaseItemQty(event) {
    event.stopPropagation();
    this.decreaseItemQty?.emit(this.cartItems[0]);
  }

  getQuantity() {
    return this.cartItems.reduce((acc, item) => acc + item.quantity, 0);
  }

  showPlusButton(): boolean {
    return OfferUtils.showPlusButton(this.offer, this.basketEnabled, this.orderingEnabled);
  }
  getBackgroundImage(url: any) {
    if (url) {
      return this.sanitizer.bypassSecurityTrustStyle(`url('${url}')`);
    }
    return '';
  }

}
